import React from "react";
import { Route, Switch } from "react-router-dom";
import AboutUs from "../Screens/AboutUs/AboutUs";
import ContactUs from "../Screens/ContactUs/ContactUs";
import Home from "../Screens/Home/Home";
import Payment from "../Screens/Payment/Payment";
import PaymentHistory from "../Screens/PaymentHistory/PaymentHistory";
import Profile from "../Screens/Profile/Profile";
import UsageManagment from "../Screens/UsageManagment/UsageManagment";
import WaitingForPay from "../Screens/WaitingForPay/WaitingForPay";
import DownloadsPage from "../Screens/Downloads";
import Terms from "../Screens/Terms/Terms";
// import Route from "./Route";
export default function Routes() {
  return (
    <Switch>
      <Route path={"/"} exact component={Home} />
      <Route path={"/aboutUs"} component={AboutUs} />
      <Route path={"/contactUs"} component={ContactUs} />
      <Route path={"/terms"} component={Terms} />
      <Route path={"/usage"} component={UsageManagment} />
      <Route path={"/history"} component={PaymentHistory} />
      <Route path={"/waiting"} component={WaitingForPay} />
      <Route path={`/Payment/:topicId`} component={Payment} />
      <Route path={"/profile"} component={Profile} />
      <Route path={"/downloads"} component={DownloadsPage} />
    </Switch>
  );
}
